import payslipReducers from 'pages/Payslip/reducers/PayslipReducers';
import { combineReducers } from 'redux';
import loginReducer from '../pages/Login/reducers/LoginReducers';
import userProfileReducer from '../pages/UserProfile/reducers/UserProfileReducers';

export default combineReducers({
  loginReducer: loginReducer,
  userProfileReducer: userProfileReducer,
  payslipReducers: payslipReducers
})